/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod/v4';

export const progressTrendPointSchema = z.object({
  completedScope: z.int().nullish(),
  date: z.iso.date(),
  forecastedCompletedScope: z.number().nullish(),
  forecastedWorkScope: z.int().nullish(),
  plannedCompleteRate: z.number().nullish(),
  workScope: z.int().nullish(),
});
